{
  "accounts": {
    "addToOrg": {
      "placeholder": "Sélectionnez une organisation",
      "subtitle": "L'utilisateur conserve son compte, ses études et ses panels.",
      "title": "Ajouter {{name}} à une organisation"
    },
    "confirm": {
      "reactivateOrgBody": "L'organisation réapparaît dans l'application et tous ses membres peuvent à nouveau se connecter. Les crédits, les partages et le contenu archivé ne sont pas restaurés.",
      "reactivateTitle": "Réactiver {{name}}",
      "reactivateUserBody": "{{name}} peut à nouveau se connecter. Les crédits, les partages et le contenu archivé ne sont pas restaurés.",
      "removeBody": "{{name}} perdra l'accès aux études et panels partagés de {{org}}. Son compte reste actif en tant que compte individuel.",
      "removeTitle": "Retirer de l'organisation"
    },
    "credits": {
      "balance": "Nouveau solde",
      "confirm": "Enregistrer",
      "subtitle": "Définissez le solde de crédits ou passez en illimité.",
      "title": "Gérer les crédits de {{name}}"
    },
    "drawer": {
      "created": "Création",
      "creditBalance": "Solde de crédits",
      "details": "Détails",
      "id": "ID",
      "lastSignIn": "Dernière connexion",
      "libraryPanel": "Bibliothèque Foresight",
      "members": "Membres",
      "never": "Jamais",
      "noMembers": "Aucun membre pour le moment.",
      "noPanels": "Aucun panel pour le moment.",
      "offboardedAt": "Clôture",
      "ownedBy": "Appartient à {{name}}",
      "panels": "Panels",
      "panelsCount": {
        "one": "{{count}} panel",
        "other": "{{count}} panels",
        "zero": "{{count}} panel"
      }
    },
    "empty": "Aucun compte dans la région {{region}} pour le moment.",
    "emptySearch": "Aucun compte ne correspond à votre recherche.",
    "filters": {
      "all": "Tous",
      "individuals": "Individuels",
      "orgs": "Organisations",
      "showOffboarded": "Afficher les comptes clôturés"
    },
    "hiddenOtherRegion": {
      "one": "{{count}} compte hors de la région {{region}} est masqué. Changez de région pour le gérer.",
      "other": "{{count}} comptes hors de la région {{region}} sont masqués. Changez de région pour les gérer.",
      "zero": "{{count}} compte hors de la région {{region}} est masqué. Changez de région pour le gérer."
    },
    "menu": {
      "addMember": "Ajouter un membre",
      "addToOrg": "Ajouter à une organisation",
      "assignPanels": "Attribuer des panels",
      "makeAdmin": "Définir comme admin",
      "makeMember": "Définir comme membre",
      "makeOwner": "Définir comme propriétaire",
      "manageCredits": "Gérer les crédits",
      "offboardOrg": "Clôturer l'organisation",
      "offboardUser": "Clôturer le compte",
      "reactivate": "Réactiver",
      "removeFromOrg": "Retirer de l'organisation",
      "removeOwnerDisabled": "Transférez la propriété pour le retirer"
    },
    "orgsCount": {
      "one": "{{count}} organisation",
      "other": "{{count}} organisations",
      "zero": "{{count}} organisation"
    },
    "roles": {
      "admin": "Admin",
      "member": "Membre",
      "owner": "Propriétaire"
    },
    "search": "Rechercher des organisations, utilisateurs, e-mails…",
    "ssoEnabled": "SSO",
    "status": {
      "active": "Actif",
      "offboarded": "Clôturé"
    },
    "stripeLinked": "Stripe",
    "subtitle": "{{orgs}} · {{users}} · région {{region}}",
    "table": {
      "account": "Compte",
      "created": "Création",
      "credits": "Crédits",
      "lastActive": "Dernière activité",
      "members": "Membres",
      "membersCount": {
        "one": "{{count}} membre",
        "other": "{{count}} membres",
        "zero": "{{count}} membre"
      },
      "panels": "Panels",
      "status": "Statut",
      "type": "Type"
    },
    "title": "Comptes",
    "types": {
      "individual": "Individuel",
      "org": "Organisation"
    },
    "unlimitedCredits": "Illimité",
    "usersCount": {
      "one": "{{count}} utilisateur",
      "other": "{{count}} utilisateurs",
      "zero": "{{count}} utilisateur"
    }
  },
  "audienceBuilder": {
    "allGenders": "Tous les genres",
    "countryCount": {
      "one": "{{count}} pays",
      "other": "{{count}} pays",
      "zero": "Monde entier"
    },
    "extraFilters": {
      "one": "+{{count}} filtre",
      "other": "+{{count}} filtres",
      "zero": "Aucun filtre"
    }
  },
  "auth": {
    "subtitle": "La recherche continue pour les marques qui avancent vite.",
    "tagline": "Simulez chaque audience, ",
    "taglineItalic": "obtenez des insights en quelques minutes"
  },
  "console": {
    "actions": {
      "archive": "Archiver",
      "delete": "Supprimer définitivement",
      "seeRuns": "Voir les exécutions",
      "transfer": "Transférer"
    },
    "adminBadge": "Admin",
    "chart": {
      "runsOverTime": "Exécutions dans le temps",
      "runsOverTimeSubtitle": "Études + questions adhoc lancées",
      "statusBreakdown": "Répartition par statut",
      "totalRuns": {
        "one": "{{count}} exécution au total",
        "other": "{{count}} exécutions au total",
        "zero": "{{count}} exécution au total"
      }
    },
    "confirm": {
      "archiveBody": "Voulez-vous vraiment archiver « {{name}} » ?",
      "archiveTitle": "Archiver l’élément",
      "archiving": "Archivage…",
      "deleteBody": "Voulez-vous vraiment supprimer définitivement « {{name}} » ? Cette action est irréversible.",
      "deleteTitle": "Supprimer définitivement",
      "deleting": "Suppression…"
    },
    "custom": "Personnalisé",
    "from": "Du",
    "kpi": {
      "activeClients": "Comptes actifs",
      "adhoc": "Adhoc",
      "avgDuration": "Durée moy.",
      "completion": "Taux de complétion",
      "cost": "Coût",
      "respondents": {
        "one": "Répondant",
        "other": "Répondants",
        "zero": "Répondant"
      },
      "studies": "Études",
      "successRate": "Taux de succès",
      "totalRuns": "Total exécutions"
    },
    "panel": {
      "loadMore": "Charger plus",
      "loading": "Chargement…",
      "noAdhoc": "Aucune question adhoc trouvée",
      "noAdhocSearch": "Aucune question ne correspond à votre recherche",
      "noStudies": "Aucune étude trouvée",
      "noStudiesSearch": "Aucune étude ne correspond à votre recherche",
      "searchAdhoc": "Rechercher des questions…",
      "searchStudies": "Rechercher des études…",
      "tabAdhoc": "Adhoc",
      "tabStudies": "Études"
    },
    "runs": {
      "calls": {
        "one": "{{count}} appel",
        "other": "{{count}} appels",
        "zero": "{{count}} appel"
      },
      "characters": {
        "one": "{{value}} caractère",
        "other": "{{value}} caractères",
        "zero": "{{value}} caractère"
      },
      "llm": "LLM",
      "noCost": "Aucun coût enregistré pour cette exécution.",
      "noRuns": "Aucune exécution pour le moment.",
      "title": "Exécutions et coûts",
      "tokens": {
        "one": "{{value}} token",
        "other": "{{value}} tokens",
        "zero": "{{value}} token"
      },
      "total": "Total",
      "translation": "Traduction",
      "usageType": {
        "llm": {
          "chat": "Chat sur les résultats",
          "conversation": "Conversation avec le persona",
          "narrative": "Récit du persona",
          "other": "Autre",
          "research": "Recherche de personas",
          "simulation": "Simulation de persona",
          "suggest": "Suggestions de questions",
          "summary": "Résumé IA",
          "visualization": "Génération de graphiques"
        },
        "translation": {
          "content": "Traduction du contenu",
          "miscellaneous": "Libellés d'interface",
          "other": "Autre",
          "prompt": "Traduction des instructions",
          "summary": "Traduction du résumé",
          "verbatim": "Traduction des verbatims"
        }
      }
    },
    "status": {
      "completed": "Terminé",
      "draft": "Brouillon",
      "failed": "Échoué",
      "queued": "En attente",
      "running": "En cours"
    },
    "subtitle": "Vue d'ensemble — exécutions, clients & métriques de performance",
    "table": {
      "adhocCount": "Adhoc",
      "avgDuration": "Moy.",
      "client": "Client",
      "clients": "Clients",
      "clientsCount": {
        "one": "{{count}} client",
        "other": "{{count}} clients",
        "zero": "{{count}} client"
      },
      "completion": "Complétion",
      "cost": "Coût",
      "failedRuns": "Échecs",
      "lastRun": "Dernière exéc.",
      "membersCount": {
        "one": "{{count}} membre",
        "other": "{{count}} membres",
        "zero": "{{count}} membre"
      },
      "studyCount": "Études",
      "successRate": "Succès",
      "successRuns": "Succès",
      "totalRuns": "Exéc."
    },
    "title": "Console Interne",
    "transfer": {
      "confirm": "Transférer",
      "external": "Externe",
      "noResults": "Aucun utilisateur trouvé.",
      "searchHint": "Recherchez un utilisateur par nom ou e-mail.",
      "searchPlaceholder": "Rechercher des utilisateurs…",
      "subtitle": "Réattribuer la propriété à un autre utilisateur.",
      "title": "Transférer l’étude",
      "transferring": "Transfert…"
    }
  },
  "credentials": {
    "copied": "Copié",
    "copy": "Copier",
    "email": "E-mail",
    "password": "Mot de passe",
    "subtitle": "Transmettez-les au client. Les mots de passe ne seront plus affichés.",
    "title": "Identifiants de connexion"
  },
  "errors": {
    "unknown": "Une erreur est survenue. Veuillez réessayer."
  },
  "forms": {
    "optional": "Facultatif",
    "org": {
      "addDomain": "Ajouter",
      "credits": "Crédits de départ",
      "creditsHint": "Ajoutés au solde de crédits lors de la création.",
      "domains": "Domaines e-mail",
      "domainsHint": "Seules les adresses e-mail de ces domaines peuvent rejoindre cette organisation.",
      "domainsRequired": "Ajoutez au moins un domaine.",
      "enrollment": {
        "automaticInvitation": "Invitation automatique",
        "automaticSuggestion": "Suggérer de rejoindre",
        "enterpriseSso": "SSO",
        "manualInvitation": "Invitation manuelle uniquement"
      },
      "logo": "Logo",
      "logoHint": "PNG ou JPG. Les images carrées rendent mieux.",
      "logoRemove": "Supprimer",
      "logoReplace": "Remplacer",
      "logoUpload": "Importer une image",
      "name": "Nom de l'organisation",
      "region": "Région",
      "regionHint": "Tous les membres de cette organisation sont rattachés à cette région.",
      "seatLimit": "Limite de membres",
      "seatLimitHint": "Laissez vide pour un nombre illimité de membres.",
      "slug": "Slug",
      "slugHint": "Utilisé dans les URL. Généré à partir du nom.",
      "stripeCustomerId": "ID client Stripe",
      "stripeCustomerIdHint": "Associe la facturation à un client Stripe existant.",
      "unlimitedCredits": "Crédits illimités"
    },
    "owner": {
      "existing": "Utilisateur existant",
      "new": "Nouvel utilisateur",
      "subtitle": "Devient admin de l'organisation et propriétaire par défaut des panels attribués.",
      "title": "Propriétaire"
    },
    "panels": {
      "assign": {
        "one": "Attribuer {{count}} panel",
        "other": "Attribuer {{count}} panels",
        "zero": "Attribuer {{count}} panel"
      },
      "assignSubtitle": "Donnez à ce client des panels de la bibliothèque Foresight.",
      "assignTitle": "Attribuer des panels à {{name}}",
      "copy": "Copier dans le compte",
      "copyDescription": "Le client reçoit sa propre copie. Les mises à jour de la bibliothèque ne sont pas répercutées.",
      "default": "Panel par défaut",
      "defaultHint": "Présélectionné quand le client crée une étude.",
      "defaultNone": "Aucun",
      "library": "Bibliothèque de panels",
      "libraryEmpty": "Aucun panel dans la bibliothèque de cette région.",
      "librarySubtitle": "Panels de la bibliothèque de cette région",
      "mode": "Mode d'attribution",
      "noMatches": "Aucun panel ne correspond à votre recherche.",
      "orgAccess": "Accès de l'organisation",
      "orgAccessHint": "Ce que les autres membres de l'organisation peuvent faire avec ces panels.",
      "owner": "Propriétaire",
      "ownerHint": "Les copies appartiennent à ce membre.",
      "ownerPlaceholder": "Sélectionnez un membre",
      "restricted": "Restreint",
      "searchPlaceholder": "Rechercher des panels…",
      "selectedCount": {
        "one": "{{count}} sélectionné",
        "other": "{{count}} sélectionnés",
        "zero": "{{count}} sélectionné"
      },
      "share": "Partager le panel de la bibliothèque",
      "shareDescription": "Lien en lecture seule vers le panel de la bibliothèque. Les mises à jour sont répercutées automatiquement.",
      "view": "Peut consulter"
    },
    "placeholders": {
      "domain": "marque.fr",
      "email": "marie.dupont@marque.fr",
      "firstName": "Marie",
      "lastName": "Dupont",
      "memberEmail": "collegue@marque.fr",
      "orgName": "Boissons Acme",
      "slug": "boissons-acme",
      "stripeCustomerId": "cus_…"
    },
    "regionLockHint": "Identique à la région affichée. Modifiez-la depuis la barre du haut.",
    "required": "Obligatoire",
    "saving": "Enregistrement…",
    "user": {
      "addMember": "Ajouter un membre",
      "addMemberSubtitle": "Les nouveaux membres sont rattachés à la région de l'organisation.",
      "addMemberTitle": "Ajouter un membre à {{name}}",
      "create": "Créer l'utilisateur",
      "createSubtitle": "Crée l'utilisateur Clerk dans votre région actuelle.",
      "createTitle": "Nouvel utilisateur",
      "creditsHint": "Ajoutés au solde de crédits de l'utilisateur. Les membres d'une organisation utilisent le solde de crédits de l'organisation.",
      "email": "E-mail",
      "emailDomain": "Utilisez une adresse e-mail en {{domains}}.",
      "emailInvalid": "Saisissez un e-mail valide.",
      "firstName": "Prénom",
      "lastName": "Nom",
      "noOrg": "Aucune organisation (individuel)",
      "org": "Organisation",
      "orgHint": "Laissez vide pour un compte individuel.",
      "regionFromOrg": "Héritée de {{name}}.",
      "role": "Rôle",
      "seatLimitReached": {
        "one": "Cela dépasse la limite de {{count}} membre.",
        "other": "Cela dépasse la limite de {{count}} membres.",
        "zero": "Cela dépasse la limite de {{count}} membre."
      }
    },
    "userPicker": {
      "change": "Modifier",
      "inOrg": "Déjà dans {{name}}",
      "noResults": "Aucun utilisateur trouvé.",
      "offboarded": "Clôturé",
      "otherDomain": "L'e-mail n'est pas en {{domains}}",
      "otherRegion": "Autre région",
      "placeholder": "Rechercher par nom ou e-mail…"
    }
  },
  "misc": {
    "archived": "Archivé",
    "cancel": "Annuler",
    "daysShort": "{{count}}j",
    "errorOccurred": "Une erreur s'est produite.",
    "hoursShort": "{{count}}h",
    "minutesShort": "{{count}}m",
    "retrying": "Nouvelle tentative...",
    "secondsShort": "{{count}}s",
    "tryAgain": "Réessayer",
    "unknown": "Inconnu"
  },
  "nav": {
    "accounts": "Comptes",
    "onboardClient": "Intégrer un client",
    "usage": "Utilisation"
  },
  "notFound": {
    "goToHomeScreen": "Aller à l'écran d'accueil",
    "notFound": "Impossible de trouver ce que vous cherchez"
  },
  "offboard": {
    "confirmOrg": "Clôturer l'organisation",
    "confirmUser": "Clôturer le compte",
    "contentLabel": "Études, questions adhoc et panels",
    "deactivate": "Désactiver les membres",
    "deactivateDescription": "Bloque la connexion de tous les membres et révoque leurs sessions.",
    "delete": "Supprimer définitivement",
    "deleteDescription": "Supprime tout le contenu. Cette action est irréversible.",
    "detach": "Retirer uniquement de l'organisation",
    "detachDescription": "Les membres conservent un compte individuel mais perdent l'accès partagé.",
    "effectsTitle": "Ce qui va se passer",
    "keep": "Conserver (archivé)",
    "keepDescription": "Archivé et récupérable par un admin Foresight.",
    "membersLabel": "Membres",
    "newOwner": "Nouveau propriétaire de l'organisation",
    "newOwnerHint": "Obligatoire : cet utilisateur est propriétaire de l'organisation.",
    "newOwnerPlaceholder": "Sélectionnez un membre",
    "offboarding": "Clôture…",
    "orgEffects": "Les partages de l'organisation sont révoqués, les crédits restants sont perdus et l'organisation est masquée dans l'application.",
    "orgSubtitle": "Ferme l'organisation du client et ses accès.",
    "ownerBlocked": "Cet utilisateur est le seul membre de {{name}}. Clôturez plutôt l'organisation.",
    "stats": {
      "credits": "Crédits",
      "members": "Membres",
      "panels": "Panels"
    },
    "staysInOrg": "Cet utilisateur reste dans {{name}} en tant que membre désactivé.",
    "title": "Clôturer {{name}}",
    "typeToConfirm": "Saisissez {{value}} pour confirmer",
    "userEffects": "La connexion est désactivée, les sessions actives sont révoquées, les partages directs sont supprimés et les crédits restants sont perdus.",
    "userSubtitle": "Désactive le compte."
  },
  "onboard": {
    "addMember": "Ajouter un membre",
    "back": "Retour",
    "done": "Terminé",
    "doneSubtitle": "Les comptes et les panels sont prêts.",
    "doneTitle": "Client intégré",
    "individualDescription": "Un seul utilisateur avec son propre solde de crédits.",
    "individualType": "Individuel",
    "launch": "Intégrer le client",
    "memberErrors": "Renseignez le prénom, le nom et une adresse e-mail unique en {{domains}} pour chaque membre.",
    "members": "Membres",
    "membersSubtitle": "Ajoutés à l'organisation.",
    "next": "Suivant",
    "noMembers": "Aucun autre membre. Vous pourrez en ajouter plus tard.",
    "orgDescription": "Une équipe qui partage un solde de crédits, des panels et des études.",
    "orgType": "Organisation",
    "owner": "Propriétaire",
    "pasteAdd": "Ajouter les e-mails",
    "pasteList": "Coller une liste",
    "pastePlaceholder": "Collez des e-mails séparés par des virgules, des espaces ou des retours à la ligne",
    "regionNote": "Tous les membres de cette organisation sont créés dans la région {{region}}, celle de l'organisation.",
    "review": {
      "edit": "Modifier",
      "individual": "Individuel",
      "name": "Nom",
      "noPanels": "Aucun panel attribué.",
      "org": "Organisation",
      "unlimited": "Illimité"
    },
    "running": "Intégration…",
    "stepOf": "Étape {{current}} sur {{total}}",
    "steps": {
      "client": "Client",
      "panels": "Panels",
      "people": "Personnes",
      "review": "Vérification"
    },
    "subtitle": "Tout est créé dans la région {{region}}.",
    "tasks": {
      "addMembers": {
        "one": "Ajout de {{count}} membre",
        "other": "Ajout de {{count}} membres",
        "zero": "Ajout de {{count}} membre"
      },
      "createOrg": "Création de {{name}} dans la région {{region}}",
      "createOwner": "Création du compte propriétaire pour {{name}}",
      "createUser": "Création de {{name}} dans la région {{region}}",
      "panels": {
        "one": "Attribution de {{count}} panel",
        "other": "Attribution de {{count}} panels",
        "zero": "Attribution de {{count}} panel"
      }
    },
    "title": "Intégrer un client"
  },
  "panels": {
    "default": "Par défaut"
  },
  "region": {
    "eu": "Europe",
    "switch": "Changer de région",
    "switchBody": "Vous verrez et gérerez les comptes de la région {{name}}.",
    "switchScope": "Cela change votre région dans tout Foresight, pas seulement dans la console : l'application Foresight affichera aussi les données de la région {{name}}, et les tokens que vous générez dans la console seront valables pour la région {{name}}.",
    "switchTitle": "Passer à la région {{name}} ?",
    "switching": "Changement…",
    "us": "États-Unis"
  }
}
